import { form } from '../../../lib/apiList'
import axios from '../../../lib/axios'

const getAllForms = () => {
    const response = axios.post(form.GET_FORMS, {})
    return response
}
const createForm = (data: FormData) => {
    const response = axios.post(form.CREATE_FORM, data)
    return response
}
const delForm = (id: string) => {
    const response = axios.delete(form.DELETE_FORM, { data: { id } })
    return response
}
const getForm = (id: string) => {
    const response = axios.get(form.GET_FORM + id)
    return response
}
const updateForm = (data: FormData) => {
    const response = axios.put(form.UPDATE_FORM, data)
    return response
}
const getAssignedUsers = async (id: string) => {
    const response = await axios.get(form.GET_ASSIGNED_USER + id)
    return response
}
const delAssignUser = async (formId: string, userId: string[]) => {
    const data = {
        formId: formId,
        userId: userId,
    }
    const response = await axios.delete(form.DELETE_ASSIGNED_USER, {
        data: data,
    })
    return response
}
const assignForm = async (data: any) => {
    const response = await axios.post(form.ASSIGN_FORM, data)
    return response
}

const loadFormAssignedToMe = async () => {
    const response = await axios.post(form.FORM_ASSIGNED_TO_ME, {})
    return response
}

const submitForm = async (file: File, id: string) => {
    // from submit by user Employee
    const formData = new FormData()
    formData.append('id', id)
    formData.append('File', file)
    const response = await axios.post(form.SUBMIT_FORM, formData)
    return response
}

const downloadForm = async (id: string) => {
    const url = form.DOWNLOAD_FORM.replace(':resourceID', id)
    const response = await axios.post(url + '?type=Form', {
        resourceId: id,
        type: 'Form',
    })
    return response
}

const downloadUploadedForm = async (userId: string | null, formId: string) => {
    if (!userId) {
        throw new Error('userId is required')
    }
    const url = form.DOWNLOAD_UPDLOADED_FORM.replace(
        '{userId}',
        userId
    ).replace('{formId}', formId)
    const response = await axios.get(url)
    return response
}

export {
    getAllForms,
    createForm,
    delForm,
    getForm,
    updateForm,
    getAssignedUsers,
    delAssignUser,
    assignForm,
    loadFormAssignedToMe,
    submitForm,
    downloadForm,
    downloadUploadedForm,
}
